import classNames from 'classnames';
import React from 'react';
import IconCollection from '../IconCollection/IconCollection';
import css from "./MobileStore.module.css"

const MERCHANT_APP_APP_STORE = "https://apps.apple.com/in/app/now-offers-merchant/id6742392597";
const MERCHANT_APP_PLAY_STORE = "https://play.google.com/store/apps/details?id=com.now.merchant&pcampaignid=web_share";
const CUSTOMER_APP_APP_STORE = "https://apps.apple.com/in/app/now-offers-customer/id6742392519";
const CUSTOMER_APP_PLAY_STORE =
  "https://play.google.com/store/apps/details?id=com.now.customer&pcampaignid=web_share";

const MobileStore = ({ className, merchant = false }) => {
  const playStoreLink = merchant ? MERCHANT_APP_PLAY_STORE : CUSTOMER_APP_PLAY_STORE;
  const appStoreLink = merchant ? MERCHANT_APP_APP_STORE : CUSTOMER_APP_APP_STORE;

  return (
    <div className={classNames(css.mobileStore, className)}>
      {playStoreLink ?
        <a
          href={playStoreLink}
          target='_blank'
          rel="noopener noreferrer"
        >
          <IconCollection name="google_store" />
        </a> : null}

      {appStoreLink ?
        <a
          href={appStoreLink}
          target='_blank'
          rel="noopener noreferrer"
        >
          <IconCollection name="apple_store" />
        </a> : null}
    </div>
  );
};

export default MobileStore;
